import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { Component, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { AppFloatingConfigurator } from "../../../layout/component/app.floatingconfigurator";
import { Menu, MenuModule } from "primeng/menu";
import { ButtonModule } from "primeng/button";
import { MenuItem, MessageService, ConfirmationService } from "primeng/api";
import { Popover, PopoverModule } from "primeng/popover";
import { InputTextModule } from "primeng/inputtext";
import { SharedModule } from "src/app/private/shared/shared.module";
import { AddLeadComponent } from "../../components/leads/add-lead/add-lead.component";
import { LeadService } from "src/app/private/services/lead.service";
import { LocalStorageService } from "src/app/utils/LocalStorageService";
import { UsersService } from "src/app/private/services/users.service";
import { DeleteLeadComponent } from "../../components/leads/delete-lead/delete-lead.component";
import { BulkUploadComponent } from "../../components/leads/bulk-upload/bulk-upload.component";
import * as XLSX from 'xlsx';
import { ThLargeIcon } from "primeng/icons";
import { saveAs } from 'file-saver';
import { Router } from "@angular/router";
import { BulkUpdateComponent } from "../../components/leads/bulk-update/bulk-update.component";
import { BulkDeleteComponent } from "../../components/leads/bulk-delete/bulk-delete.component";
import { UpdateLeadSpaceComponent } from "../../components/leads/update-lead-space/update-lead-space.component";
import { DeleteLeadSpaceComponent } from "../../components/leads/delete-lead-space/delete-lead-space.component";
import { MoveLeadSpaceComponent } from "../../components/leads/move-lead-space/move-lead-space.component";
import { MoveBulkLeadSpaceComponent } from "../../components/leads/move-bulk-lead-space/move-bulk-lead-space.component";
import { LeadEmailComponent } from "../../components/leads/lead-email/lead-email.component";
import { LeadCallComponent } from "../../components/leads/lead-call/lead-call.component";
import { MoveToRegistrationComponent } from "../../components/leads/move-to-registration/move-to-registration.component";
import { BulkMoveToRegistrationComponent } from "../../components/leads/bulk-move-to-registration/bulk-move-to-registration.component";
import { WhatsappCommunicationComponent } from "../../components/leads/whatsapp-communication/whatsapp-communication.component";
import { LeadFollowupFormComponent } from "../../components/leads/lead-followup-form/lead-followup-form.component";
import { LeadFollowupFormPopupComponent } from "../../components/leads/lead-followup-form-popup/lead-followup-form-popup.component";
import { FindDuplicateLeadsComponent } from "../../components/leads/find-duplicate-leads/find-duplicate-leads.component";
import { ConfirmDialogModule } from 'primeng/confirmdialog';


@Component({
  selector: 'app-leads',
  imports: [ToolBarComponent,
    CommonModule, TableModule, ProgressSpinnerModule, DropdownModule, FormsModule, AppFloatingConfigurator,
    Menu, ButtonModule, MenuModule, PopoverModule, InputTextModule, SharedModule, AddLeadComponent, DeleteLeadComponent, BulkUploadComponent, BulkUpdateComponent, BulkDeleteComponent, UpdateLeadSpaceComponent, DeleteLeadSpaceComponent, MoveLeadSpaceComponent, MoveBulkLeadSpaceComponent, LeadEmailComponent, LeadCallComponent, MoveToRegistrationComponent, BulkMoveToRegistrationComponent, LeadFollowupFormPopupComponent, WhatsappCommunicationComponent, FindDuplicateLeadsComponent, ConfirmDialogModule],
  templateUrl: './leads.component.html',
  styleUrl: './leads.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class LeadsComponent {
  @ViewChild('op') popover!: Popover;
  leadsData: any[] = [];
  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  loading: boolean = false;
  isOpenAddDialog: boolean = false;
  isAddSpace: boolean = false;

  selectedProducts!: any[];

  displayedColumns: any[] = [];
  importColumns: any[] = [];
  exportItems: any[] = [];

  allLeadFeilds: any[] = [];
  isAdmin: boolean = true;
  isFixedColumn: boolean = true;

  items: any[] | undefined;
  tabItems: any[] | undefined;

  isEditLead: boolean = false;
  isDeleteLead: boolean = false;
  isAddNote: boolean = false;
  isAddFollowUp: boolean = false;
  isCommunicate: boolean = false;
  isOpenBulkAdd: boolean = false;
  isBulkUpdateLeads: boolean = false;
  isBulkDeleteLead: boolean = false;
  isUpdateLeadSpace: boolean = false;
  isDeleteLeadSpace: boolean = false;
  isAddToLeadSpace: boolean = false;
  isBulkMoveLeadSpace: boolean = false;
  isBulkSendEmail: boolean = false;
  isEmailLead: boolean = false;
  isWhatsappLead: boolean = false;
  isCallLead: boolean = false;
  isMoveToRegistration: boolean = false;
  isBulkMoveToRegistration: boolean = false;
  isOpenFollowUpForm: boolean = false;
  isAdminUser: boolean = false;
  isFindDuplicateLeads: boolean = false;
  duplicateCount: number = 0;

  leadDetails: any = {};

  editLeadData: any = {};

  startDate: string = '';
  endDate: string = '';
  private scriptElement: HTMLScriptElement | null = null;
  accessObject: any = {};
  appliedFilters: any = null;


  selectedDefaultPipelineId: number | null = null;



  handleCallLead(event: any) {
    this.isCallLead = true;
    this.leadDetails = event;
  }

  handleEmailLead(event: any) {
    const emailMode = this.localStorage.getDefaultEmailCommunicationMode();
    
    if (emailMode === 'none' || !emailMode) {
      this.confirmationService.confirm({
        message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
        header: 'Communication Medium Not Connected',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Connect Communication',
        rejectLabel: 'Cancel',
        acceptButtonStyleClass: 'p-button-warning',
        accept: () => {
          this.confirmationService.close();
          this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
        },
        reject: () => {
          this.confirmationService.close();
        }
      });
      return;
    }
    
    this.isEmailLead = true;
    this.leadDetails = event;
  }


  openLeadProfile(event: any) {
    this.router.navigate([`/main/leads/${event.lead_id}`]);
  }

  handleWhatsappLead(event: any) {
    this.isWhatsappLead = true;
    this.leadDetails = event;
  }

  bulkActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Update Leads',
          icon: 'pi pi-pencil',
          command: () => {
            this.isBulkUpdateLeads = true;
          }
        },

        {
          label: 'Move to Registration',
          icon: 'pi pi-file-export',
          command: () => {
            this.isBulkMoveToRegistration = true;
          }
        },
        {
          label: 'Create New Group',
          icon: 'pi pi-users',
          command: () => {
            this.isBulkMoveLeadSpace = true;
          }
        },
        {
          label: 'Send Email',
          icon: 'pi pi-envelope',
          command: () => {
            const emailMode = this.localStorage.getDefaultEmailCommunicationMode();
            
            if (emailMode === 'none' || !emailMode) {
              this.confirmationService.confirm({
                message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
                header: 'Communication Medium Not Connected',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Connect Communication',
                rejectLabel: 'Cancel',
                acceptButtonStyleClass: 'p-button-warning',
                accept: () => {
                  this.confirmationService.close();
                  this.router.navigate(['/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
                },
                reject: () => {
                  this.confirmationService.close();
                }
              });
              return;
            }
            
            this.isBulkSendEmail = true;
          }
        },
        {
          label: 'Delete Leads',
          icon: 'pi pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            console.log('Edit Lead');
            this.isBulkDeleteLead = true;
          }
        },
      ]
    }
  ];

  filterOptions = [
    {
      label: 'Sales Owner',
      items: []
    },

    {
      label: 'Lead Type',
      items: [
        { label: 'New Lead', checked: false },
        { label: 'Cold Lead', checked: false },
        { label: 'Warm Lead', checked: false },
        { label: 'Hot Lead', checked: false },
      ],
    },
    {
      label: 'Assigned To',
      items: []
    },
    {
      label: 'Sources',
      items: [
        { label: 'Channel Partner', checked: false },
        { label: 'Conference', checked: false },
        { label: 'Field Visit', checked: false },
        { label: 'Google', checked: false },
        { label: 'Instagram', checked: false },
        { label: 'Lead Gen Tools', checked: false },
        { label: 'Live Session', checked: false },
        { label: 'Personal', checked: false },
        { label: 'Referral', checked: false },
        { label: 'LinkedIn', checked: false },
        { label: 'Website', checked: false },
        { label: 'WhatsApp', checked: false },
        { label: 'Tina', checked: false },
        { label: 'Intern', checked: false },
        { label: 'Other', checked: false }
      ],
    },
    {
      label: 'Lead Status',
      items: [],
    },
    {
      label: 'Query Type',
      items: [
        { label: 'General', checked: false },
        { label: 'Admission', checked: false },
        { label: 'Application', checked: false },
        { label: 'Fee Structure', checked: false },
        { label: 'Registration', checked: false },
        { label: 'Placement', checked: false },
        { label: 'Course', checked: false },
        { label: 'Other', checked: false }
      ],
    },
  ];


  newGroupName: string = '';

  tabs = [
    {
      label: 'All Leads',
      value: 'All Leads',
      isActive: true,
    }
  ]

  activeTab = 'All Leads';
  activeTabName = 'All Leads';

  users: any = [];

  filtersOptions: any[] = [];





  setActiveTab(tab: string) {

    let flag = tab == this.activeTab;

    this.activeTab = tab;
    this.activeTabName = this.tabs.find((item) => item.value === tab)?.label || '';

    if (!flag) {
      this.loadLeads({ first: 0, rows: this.rows });
    }
  }

  setLeadEditData(data: any) {
    this.editLeadData = data;
  }



  modules: any = [];
  permissions: any = [];
  leadActionItems: any[] = [];
  pipelineStages: any[] = [];


  constructor(private http: HttpClient,
    private api: LeadService,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private messageService: MessageService,
    private router: Router,
    private renderer: Renderer2,
    private confirmationService: ConfirmationService
  ) {

    this.accessObject = this.localStorage.checkCRUDAccess('lead', 'manual');

    this.isAdminUser = this.localStorage.isAdminUser();

    console.log("Access Object: ", this.accessObject.isMoveToRegistrationAccess);
  }




  ngOnInit() {
    this.loadLeads({ first: 0, rows: this.rows });
    this.getLeadsFields();
    this.getAllUsers();
    this.getAllLeadSpace();
    this.loadDuplicateCount();
    this.loadPipelineStages();
    // edit delete
    this.tabItems = [
      {
        label: 'Actions',
        items: [
          {
            label: 'Edit Lead Group',
            icon: 'pi pi-pencil',
            command: () => {
              this.isUpdateLeadSpace = true;
            }
          },

          {
            label: 'Delete Lead Group',
            icon: 'pi pi-trash',
            styleClass: 'delete-menu-item',
            command: () => {
              this.isDeleteLeadSpace = true;
            }
          },
        ]
      }
    ]








    if (this.isFixedColumn) {

      this.setFixedColumn()
    }

    this.setImportColumns();
    this.setExportColumns();
    this.setFilterOptions();

    this.modules = JSON.parse(this.localStorage.getFeatureModules());
    this.permissions = JSON.parse(this.localStorage.getPermissions());
    console.log("modules bot access", this.modules)
    console.log("modules bot access", this.getFeatureModuleAccess('counsellor_bot'))
    console.log("pemision bot access", this.getAccess('counsellor_bot'))
    // 
    // if (!document.getElementById('gr-ai-bot') && this.getFeatureModuleAccess('counsellor_bot') && this.getAccess('counsellor_bot')) {
    //   this.scriptElement = this.renderer.createElement('script');
    //   if (this.scriptElement) {
    //     this.scriptElement.src = 'https://chatbot.gravitasai.com/assets/widget.js';
    //     this.scriptElement.id = 'gr-ai-bot';
    //     this.scriptElement.setAttribute('data-ai', 'f989510d-7e1f-4b8a-9fb6-cf922b495e5e');
    //     this.renderer.appendChild(document.body, this.scriptElement);
    //   }
    // }


    this.leadActionItems = [
      {
        label: 'Options',
        items: [
          {
            label: 'Edit',
            icon: 'pi pi-fw pi-pencil',
            command: () => {
              this.router.navigate([`/main/leads/${this.editLeadData?.lead_id}`]);
            }
          },
          {
            label: 'Add Follow Up',
            icon: 'pi pi-plus',
            command: () => {
              this.isOpenFollowUpForm = true;
            }
          },
          {
            label: 'Move to Group',
            icon: 'pi pi-fw pi-users',
            command: () => {
              this.isAddToLeadSpace = true;
            }
          },
          {
            label: 'Move to Registration',
            icon: 'pi pi-fw pi-file-export',
            disabled: this.accessObject.isMoveToRegistrationAccess ? false : true,
            command: () => {
              this.isMoveToRegistration = true;
            }
          },
          // {
          //   label: 'Add Follow-up',
          //   icon: 'pi pi-fw pi-calendar-plus',
          //   command: () => {
          //     this.isAddFollowUp = true;
          //     this.editLeadData = rowData;
          //   }
          // },
          // {
          //   label: 'Communicate',
          //   icon: 'pi pi-fw pi-comments',
          //   command: () => {
          //     this.isCommunicate = true;
          //     this.editLeadData = rowData;
          //   }
          // },
          {
            label: 'Delete Lead',
            icon: 'pi pi-fw pi-trash',
            styleClass: 'delete-menu-item',
            command: () => {
              this.isDeleteLead = true;
            }
          }
        ]
      }
    ]
  }

  getFeatureModuleAccess(module_name: any) {
    console.log(this.modules)
    console.log(this.modules.includes(module_name))
    return (this.modules.includes(module_name) ? true : false);
  }

  getAccess(module_name: any) {
    console.log("pemision", this.permissions)
    let result = this.permissions.filter((item: any) => {
      return item.module_name == module_name && item.active == true;
    })
    console.log("gaurav", result[0])
    return (result[0]) ? true : false;
    //return true;
  }


  setFilterOptions() {
    this.filtersOptions.push({ header: 'First Name', value: 'first_name', type: 'text' });
    this.filtersOptions.push({ header: 'Last Name', value: 'last_name', type: 'text' });
    this.filtersOptions.push({ header: 'Email', value: 'email', type: 'text' });
    this.filtersOptions.push({ header: 'Phone', value: 'phone', type: 'text' });
    this.filtersOptions.push({
      header: 'Source', value: 'source', type: 'dropdown',
      options: [
        { label: 'Channel Partner', value: 'Channel Partner' },
        { label: 'Conference', value: 'Conference' },
        { label: 'Field Visit', value: 'Field Visit' },
        { label: 'Google', value: 'Google' },
        { label: 'Instagram', value: 'Instagram' },
        { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
        { label: 'Live Session', value: 'Live Session' },
        { label: 'Personal', value: 'Personal' },
        { label: 'Referral', value: 'Referral' },
        { label: 'LinkedIn', value: 'LinkedIn' },
        { label: 'Website', value: 'Website' },
        { label: 'WhatsApp', value: 'WhatsApp' },
        { label: 'Tina', value: 'Tina' },
        { label: 'Intern', value: 'Intern' },
        { label: 'Other', value: 'Other' },
      ]
    });
    this.filtersOptions.push({
      header: 'Lead Status', value: 'lead_status', type: 'dropdown',
      options: [] // populated after loadPipelineStages
    });
    this.filtersOptions.push({
      header: 'Lead Type', value: 'lead_type', type: 'dropdown',
      options: [
        { label: 'New Lead', value: 'New Lead' },
        { label: 'Cold Lead', value: 'Cold Lead' },
        { label: 'Warm Lead', value: 'Warm Lead' },
        { label: 'Hot Lead', value: 'Hot Lead' },
      ]
    });
    this.filtersOptions.push({ header: 'Query Type', value: 'query_type', type: 'text' });
    if (this.isAdminUser) {
      this.filtersOptions.push({
        header: 'Lead Owner', value: 'user_id', type: 'dropdown',
        options: [] // populated after getAllUsers
      });
      this.filtersOptions.push({
        header: 'Assign To', value: 'assigned_to', type: 'dropdown',
        options: [] // populated after getAllUsers
      });
    }
  }

  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
        this.filterOptions.forEach((item) => {
          if (item.label == 'Sales Owner') {
            item.items = this.users.map((user: any) => ({
              label: this.getUserFullName(user),
              value: user.user_id,
              checked: false
            }));
          }
          if (item.label == 'Assigned To') {
            item.items = this.users.map((user: any) => ({
              label: this.getUserFullName(user),
              value: user.user_id,
              checked: false
            }));
          }
        });
        // Populate lead_owner and assign_to dropdown options in search filters (admin only)
        this.filtersOptions.forEach((opt) => {
          if (opt.value === 'user_id' || opt.value === 'assigned_to') {
            opt.options = [
              { label: 'Not Assigned', value: null },
              ...this.users.map((user: any) => ({
                label: this.getUserFullName(user),
                value: user.user_id
              }))
            ];
          }
        });
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  loadPipelineStages() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      pipeline_type: 'lead'
    };
    this.api.getAllPipelines(param).subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          // find set_default true pipeline id
          const defaultPipeline = res.find((pipeline: any) => pipeline.set_default === true);
          if (defaultPipeline) {
            this.selectedDefaultPipelineId = defaultPipeline.id;
            
            // Populate Lead Status filter with default pipeline stages
            this.filterOptions.forEach((item) => {
              if (item.label === 'Lead Status') {
                item.items = defaultPipeline.stages.map((stage: any) => ({
                  label: stage.stage_name,
                  checked: false
                }));
              }
            });
            // Populate lead_status dropdown options in search filters
            this.filtersOptions.forEach((opt) => {
              if (opt.value === 'lead_status') {
                opt.options = defaultPipeline.stages.map((stage: any) => ({
                  label: stage.stage_name,
                  value: stage.stage_name
                }));
              }
            });
          }
          this.pipelineStages = res.map((pipeline: any) => ({
            label: pipeline.pipeline_name,
            value: pipeline.id,
            stages: pipeline.stages
          }))
        }
      },
      error: (e: any) => {
        console.error('Error loading pipeline stages:', e);
      },
    });
  }

  getLeadsFields() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      module_type: 'lead'
    };
    this.api.getLeadsFields(param).subscribe({
      next: (data) => {
        this.allLeadFeilds = data?.fields.sort((a: any, b: any) => a.sequence - b.sequence);


        data?.fields?.forEach((element: any) => {

          this.importColumns.push(
            {
              field: element?.field_name,
              header: element?.label,
              type: 'dynamic_fields'
            }
          );

          this.exportItems.push(
            {
              label: element?.label,
              value: element?.field_name,
              checked: false,
              type: 'dynamic_fields'
            }
          );

          if (element.visible_in_table == 'true' || element.visible_in_table == true) {
            this.displayedColumns.push(
              {
                field: element?.field_name,
                header: element?.label,
                type: 'dynamic_fields'
              }
            );
          }
        });

        this.displayedColumns.push(
          {
            field: 'action',
            header: 'Actions',
            type: 'actions'
          }
        );

      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllLeadSpace() {
    let param: any = {
      "where": {
        organization_id: this.localStorage.getOrganizationId(),
      }
    };

    if (!this.isAdminUser) {
      param.where['user_id'] = this.localStorage.getUserId();
    }

    this.loading = true;
    this.api.getAllLeadSpace(param).subscribe({
      next: (data) => {
        let newTabs = data?.map((item: any) => {
          return {
            label: item.space_name,
            value: item.id,
            isActive: false
          }
        });
        this.loading = false;
        this.tabs = [...this.tabs, ...newTabs];
      },
      error: (e) => {
        this.loading = false;
        console.error(e);
      },
    });
  }

  reloadTabs(activeTabName: string) {
    this.activeTabName = activeTabName;
    this.tabs = [
      {
        label: 'All Leads',
        value: 'All Leads',
        isActive: true,
      }
    ]
    this.getAllLeadSpace();
  }


  reloadTabsToAllLeads(deletedTabValue: string) {
    this.tabs = this.tabs.filter((item) => item.value !== deletedTabValue);
    this.activeTab = 'All Leads';
    this.activeTabName = 'All Leads';
    this.loadLeads({ first: 0, rows: this.rows });
  }

  // getMenuItems(menu: Menu, rowData: any) {
  //   return [

  //   ];
  // }



  reloadDataTable() {
    this.selectedProducts = [];
    this.loadLeads({ first: 0, rows: this.rows });
  }

  loadLeads(event: any, searchValue?: string, searchAttribute?: string) {
    // If filters are applied, use leadAdvanceFilter API
    if (this.appliedFilters && this.appliedFilters.some((group: any) => group.items.length > 0)) {
      const page = Math.floor(event.first / event.rows) + 1;

      const payload: any = {
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId(),
        page: page,
        limit: event.rows,
        current_stage: ["lead"],
        order: {
          col: "updatedAt",
          dir: "DESC"
        }
      };

      // Add date filters
      if (this.startDate && this.endDate) {
        payload.date_from = this.startDate;
        payload.date_to = this.endDate;
      }

      // Process applied filters
      this.appliedFilters.forEach((group: any) => {
        if (group.items && group.items.length > 0) {
          switch (group.label) {
            case 'Sales Owner':
              payload.user_id = group.items.map((item: any) => item.value);
              break;
            case 'Assigned To':
              payload.assigned_to = group.items.map((item: any) => item.value);
              break;
            case 'Lead Type':
              payload.lead_type = group.items.map((item: any) => item.label);
              break;
            case 'Sources':
              payload.sources = group.items.map((item: any) => item.label);
              break;
            case 'Lead Status':
              payload.lead_status = group.items.map((item: any) => item.label);
              break;
            case 'Query Type':
              payload.query_type = group.items.map((item: any) => item.label);
              break;
          }
        }
      });

      this.loading = true;
      this.api.leadAdvanceFilter(payload).subscribe({
        next: (data) => {
          this.leadsData = data.rows || [];
          this.totalRecords = data.count || 0;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
      return;
    }

    // Default behavior - use original getAllLeads API
    this.loading = true;

    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;

    const body: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId(),
        "lead_space_id": this.activeTab === 'All Leads' ? undefined : this.activeTab,
        // "current_stage": "lead"
        "is_actual_lead": true
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"lead\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if (!this.isAdminUser) {
      body.where['user_id'] = this.localStorage.getUserId();
    }

    if (searchAttribute && (searchValue || searchValue === null)) {
      body.filter = {
        ...body.filter,
        // "current_stage": "lead",
        "is_actual_lead": true,
        [searchAttribute]: searchValue
      }

      if (!this.isAdminUser) {
        body.filter['user_id'] = this.localStorage.getUserId();
      }
    }

    if (this.startDate && this.endDate) {
      body.startDate = this.startDate;
      body.endDate = this.endDate;
    }

    this.api.getAllLeads(body).subscribe({
      next: (data) => {
        this.leadsData = data.rows
        this.totalRecords = data.count;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  onPageSizeChange(event: any) {
    this.rows = event.value;
    this.loadLeads({ first: 0, rows: this.rows }); // Reload with new page size
  }

  handleAddGroup(event: any) {


    const payload: any = {
      space_name: this.newGroupName,
      organization_id: this.localStorage.getOrganizationId()
    }

    if (!this.isAdminUser) {
      payload['user_id'] = this.localStorage.getUserId();
    }

    this.isAddSpace = true;


    this.api.createLeadSpace(payload).subscribe({
      next: (data) => {
        const tabToAdd = {
          label: this.newGroupName,
          value: data?.id,
          isActive: false,
        }

        this.tabs.push(tabToAdd);
        this.newGroupName = '';
        this.isAddSpace = false;

        this.popover.toggle(event);


      },
      error: (e) => {
        this.isAddSpace = false;
        this.popover.toggle(event);
        console.error(e);
      },
    });


  }

  removeSelectedProducts() {
    this.selectedProducts = [];
  }

  handleBulkAction(event: any) {
    console.log('Bulk Action');
  }

  fnHandleAddd() {
    this.isOpenAddDialog = true;
  }

  setFixedColumn() {

    this.displayedColumns.push({
      field: 'lead_id',
      header: 'Lead ID',
      type: 'lead_id'
    });

    this.displayedColumns.push({
      field: 'contact_name',
      header: 'Contact Name',
      type: 'contact_name'
    });

    this.displayedColumns.push({
      field: 'createdAt',
      header: 'Added On',
      type: 'date'
    });

    this.displayedColumns.push({
      field: 'Communicate',
      header: 'Communicate',
      type: 'communicate'
    });

    this.displayedColumns.push({
      field: 'user',
      header: 'Lead Owner',
      type: 'nested'
    });

    this.displayedColumns.push({
      field: 'lead_status',
      header: 'Lead Status',
      type: 'status'
    });

    this.displayedColumns.push({
      field: 'lead_type',
      header: 'Lead Type',
    });

    this.displayedColumns.push({
      field: 'source',
      header: 'Source',
      type: 'source'
    });

    this.displayedColumns.push({
      field: 'query_type',
      header: 'Query Type',
      type: 'query_type'
    });

    this.displayedColumns.push({
      field: 'lead_score',
      header: 'Lead Score',
      type: 'lead_score'
    });

    this.displayedColumns.push({
      field: 'Assigned To',
      header: 'Assigned To',
      type: 'assigned_to'
    });

  }

  setImportColumns() {
    this.importColumns.push({ field: 'prefix', header: 'Prefix' }),
      this.importColumns.push({ field: 'first_name', header: 'First Name' }),
      this.importColumns.push({ field: 'last_name', header: 'Last Name' }),
      this.importColumns.push({ field: 'phone', header: 'Phone' }),
      this.importColumns.push({ field: 'email', header: 'Email' }),
      this.importColumns.push({ field: 'source', header: 'Source' }),
      this.importColumns.push({ field: 'lead_status', header: 'Lead Status' }),
      this.importColumns.push({ field: 'lead_type', header: 'Lead Type' }),
      this.importColumns.push({ field: 'city', header: 'City' }),
      this.importColumns.push({ field: 'state', header: 'State' }),
      this.importColumns.push({ field: 'country', header: 'Country' }),
      this.importColumns.push({ field: 'query_type', header: 'Query Type' }),
      this.importColumns.push({ field: 'lead_score', header: 'Lead Score' }),
      this.importColumns.push({ field: 'date_of_birth', header: 'Date of Birth' }),
      this.importColumns.push({ field: 'age', header: 'Age' }),
      this.importColumns.push({ field: 'gender', header: 'Gender' }),
      this.importColumns.push({ field: 'nationality', header: 'Nationality' }),
      this.importColumns.push({ field: 'address', header: 'Address' }),
      this.importColumns.push({ field: 'postal_code', header: 'Postal Code' }),
      this.importColumns.push({ field: 'alternate_phone', header: 'Alternate Phone' }),
      this.importColumns.push({ field: 'interested_course', header: 'Interested Course' }),
      this.importColumns.push({ field: 'preferred_location', header: 'Preferred Location' }),
      this.importColumns.push({ field: 'remarks', header: 'Remarks' })
  }

  setExportColumns() {
    this.exportItems.push({ label: 'Prefix', value: 'prefix', checked: false });
    this.exportItems.push({ label: 'First Name', value: 'first_name', checked: false });
    this.exportItems.push({ label: 'Last Name', value: 'last_name', checked: false });
    this.exportItems.push({ label: 'Contact Phone', value: 'phone', checked: false });
    this.exportItems.push({ label: 'Contact Email', value: 'email', checked: false });
    this.exportItems.push({ label: 'Source', value: 'source', checked: false });
    this.exportItems.push({ label: 'Lead Status', value: 'lead_status', checked: false });
    this.exportItems.push({ label: 'Lead Type', value: 'lead_type', checked: false });
    this.exportItems.push({ label: 'City', value: 'city', checked: false });
    this.exportItems.push({ label: 'State', value: 'state', checked: false });
    this.exportItems.push({ label: 'Country', value: 'country', checked: false });
    this.exportItems.push({ label: 'Query Type', value: 'query_type', checked: false });
    this.exportItems.push({ label: 'Lead Score', value: 'lead_score', checked: false });
    this.exportItems.push({ label: 'Date of Birth', value: 'date_of_birth', checked: false });
    this.exportItems.push({ label: 'Age', value: 'age', checked: false });
    this.exportItems.push({ label: 'Gender', value: 'gender', checked: false });
    this.exportItems.push({ label: 'Nationality', value: 'nationality', checked: false });
    this.exportItems.push({ label: 'Address', value: 'address', checked: false });
    this.exportItems.push({ label: 'Postal Code', value: 'postal_code', checked: false });
    this.exportItems.push({ label: 'Alternate Phone', value: 'alternate_phone', checked: false });
    this.exportItems.push({ label: 'Interested Course', value: 'interested_course', checked: false });
    this.exportItems.push({ label: 'Preferred Location', value: 'preferred_location', checked: false });
    this.exportItems.push({ label: 'Remarks', value: 'remarks', checked: false });
  }


  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' ');
  }

  getUserFullName(user: any) {
    return [user?.fname, user?.lname]
      .filter(name => !!name)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' ');
  }

  getLeadSourceImg(source: string) {
    if (source == 'tina') {
      source = 'Tina'
    } else if (source == 'whatsapp') {
      source = 'WhatsApp'
    } else if (source == 'manual') {
      source = 'Manual'
    }
    return `/assets/images/${source}.png`;
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Qualified': return '#1FAF38';
      case 'Working': return '#F0950C';
      case 'Unqualified': return '#D74843';
      case 'Raw': return '#F0950C';
      default: return '#1FAF38'
    }
  }

  handleOpenBulkAdd() {
    this.isOpenBulkAdd = true;
  }

  export(selectedFields: any) {

    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        // current_stage: 'lead',
        is_actual_lead: true,
        campus_id: this.localStorage.getCampusId(),
      },
    };


    if (!this.isAdminUser) {
      param.where['user_id'] = this.localStorage.getUserId();
    }

    this.messageService.add({
      severity: 'info', summary: 'Exporting',
      detail: 'Exporting data, please wait...',
      sticky: true
    });

    this.api.getAllLeadList(param).subscribe({
      next: (data: any) => {

        const mappedData = data.map((lead: any) => {
          let row: any = {};

          selectedFields.forEach((field: any) => {
            if (field.type === 'dynamic_fields') {
              // Handle dynamic fields
              row[field.label] = lead.dynamic_fields?.[field.value] || '';
            } else {
              row[field.label] = lead[field.value] || '';
            }
          });

          return row;
        });

        // Create worksheet & workbook
        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');

        // Save the file
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        const date = new Date();
        const fileName = `Leads_data_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getTime()}.xlsx`;

        saveAs(dataBlob, fileName);


        this.messageService.clear();

        this.exportItems.forEach((item) => {
          item.checked = false;
        }
        );

      },
      error: (e) => {

        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error exporting data' });

      },
    });
  }

  handleSearch(event: any) {
    console.log(event);
    this.loadLeads({ first: 0, rows: this.rows }, event.value, event.selectedFilterAttribute);
  }

  handleDateFilter(event: any) {
    // console.log('Date Filter:', event);
    if (event.startDate && event.endDate) {
      this.startDate = event.startDate;
      this.endDate = event.endDate;
      this.loadLeads({ first: 0, rows: this.rows }, undefined, undefined);
    } else {
      this.startDate = '';
      this.endDate = '';
      this.loadLeads({ first: 0, rows: this.rows });
    }
  }

  handleResetFilters() {
    this.startDate = '';
    this.endDate = '';
    this.loadLeads({ first: 0, rows: this.rows });
  }

  handleFindDuplicates() {
    this.isFindDuplicateLeads = true;
  }

  loadDuplicateCount() {
    const params: any = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    if (!this.isAdminUser) {
      params['user_id'] = this.localStorage.getUserId();
    }

    this.api.findDuplicateWithCount(params).subscribe({
      next: (response: any) => {
        this.duplicateCount = response.total_duplicate_groups || 0;
      },
      error: (error: any) => {
        console.error('Error loading duplicate count:', error);
        this.duplicateCount = 0;
      }
    });
  }

  handleClearFilter() {
    // Clear applied filters
    this.appliedFilters = null;

    // Reload table with default data (no filters)
    this.loadLeads({ first: 0, rows: this.rows });

    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Filters cleared successfully'
    });
  }

  handleApplyFilter(filterData: any) {
    console.log('Applied Filters:', filterData);


    // Store applied filters
    this.appliedFilters = filterData;

    // Build the payload for leadAdvanceFilter API
    const payload: any = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId(),
      page: 1,
      limit: this.rows,
      current_stage: ["lead"],
      order: {
        col: "updatedAt",
        dir: "DESC"
      }
    };

    // Add date filters if available
    if (this.startDate && this.endDate) {
      payload.date_from = this.startDate;
      payload.date_to = this.endDate;
    }

    // Process filter data
    filterData.forEach((group: any) => {
      if (group.items && group.items.length > 0) {
        switch (group.label) {
          case 'Sales Owner':
            payload.user_id = group.items.map((item: any) => item.value);
            break;
          case 'Assigned To':
            payload.assigned_to = group.items.map((item: any) => item.value);
            break;
          case 'Lead Type':
            payload.lead_type = group.items.map((item: any) => item.label);
            break;
          case 'Sources':
            payload.sources = group.items.map((item: any) => item.label);
            break;
          case 'Lead Status':
            payload.lead_status = group.items.map((item: any) => item.label);
            break;
          case 'Query Type':
            payload.query_type = group.items.map((item: any) => item.label);
            break;
        }
      }
    });

    console.log('Filter Payload:', payload);

    // Call the leadAdvanceFilter API
    this.loading = true;
    this.api.leadAdvanceFilter(payload).subscribe({
      next: (data) => {
        this.leadsData = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;

      },
      error: (error) => {
        console.error('Filter error:', error);
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error applying filters'
        });
      }
    });
  }

}
